import { useEffect, useLayoutEffect, useRef } from "react";
import type { HomeLocale } from "./homeContent";
import { homeBaseLang } from "./homeContent";
import { getHongKongHomeSeoDocument } from "./seoConfig";
import { installDentalScrollRestoration } from "./dentalReloadScroll";
import { installHongKongHomeAnalytics } from "./hongKongHomeAnalytics";
import { HomeNav } from "./components/home/HomeNav";
import { HongKongHomeSections } from "./components/home/HongKongHomeSections";
import "./components/home/home.css";
import { Nav } from "./components/Nav";
import { OriginalHomeHero } from "./components/OriginalHomeHero";
import { Hero } from "./components/Hero";
import { PainPoints } from "./components/PainPoints";
import { MeetClawEase } from "./components/MeetClawEase";
import { HowItWorks } from "./components/HowItWorks";
import { Pricing } from "./components/Pricing";
import { CTA } from "./components/CTA";
import { Footer } from "./components/Footer";
import { Seo } from "./components/Seo";

// 渲染 ClawEase 官网首页，语言由路由传入，未指定时默认英文。
export function ClaweaseSite({ defaultLang = "en" }: { defaultLang?: HomeLocale }) {
  const lang = homeBaseLang(defaultLang);
  const hongKong = defaultLang === "zh-HK";
  const mainRef = useRef<HTMLElement>(null);
  const pageRef = useRef<HTMLDivElement>(null);
  /* 重新整理（或上一頁/下一頁）時停留在當前板塊：開發環境初始 DOM 為空白，
     瀏覽器原生捲動恢復會失敗退回頂部，這裡用牙科頁同款的手動保存/恢復。 */
  useLayoutEffect(() => {
    if (mainRef.current) return installDentalScrollRestoration(mainRef.current);
  }, []);
  useEffect(() => {
    if (hongKong && pageRef.current) return installHongKongHomeAnalytics(pageRef.current);
  }, [hongKong]);

  if (!hongKong) return (
    <div className="min-h-screen bg-[#f8f9fa] text-[#100f12] font-sans">
      <Seo lang={lang} page="home" />
      <Nav lang={lang} showRegionSelector={lang === "en"} />
      <OriginalHomeHero lang={lang} />
      <PainPoints lang={lang} />
      <MeetClawEase lang={lang} />
      <HowItWorks lang={lang} />
      <Pricing lang={lang} />
      <div className="relative overflow-hidden bg-[#f8f9fa]">
        <div
          className="pointer-events-none absolute inset-0 opacity-90"
          style={{
            background:
              "radial-gradient(circle at 24% 6%, rgba(153, 108, 255, .17), transparent 30%), radial-gradient(circle at 76% 14%, rgba(233, 48, 201, .13), transparent 28%), radial-gradient(circle at 50% 100%, rgba(124, 58, 237, .18), transparent 34%), linear-gradient(180deg, rgba(246, 238, 255, .62) 0%, rgba(248,249,250,.96) 34%, rgba(242,239,249,.92) 100%)",
          }}
        />
        <div className="relative"><CTA lang={lang} /><Footer lang={lang} /></div>
      </div>
    </div>
  );

  return (
    <div className="ce-home-page min-h-screen font-sans" ref={pageRef}>
      <Seo lang={lang} page="home" documentLanguage="zh-HK" document={getHongKongHomeSeoDocument()} />
      <HomeNav locale={defaultLang} />
      <main ref={mainRef}>
      <Hero key={defaultLang} lang={defaultLang} />
      <HongKongHomeSections />
      </main>
    </div>
  );
}
